import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 30,
  medium: 23,
  small: 18,
  xSmall: 12
};
const FavoriteNavIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.69461 7.09555C3.4981 9.29704 3.42972 12.8558 5.53129 15.11L5.68823 15.2732L15.0017 24.6079L24.2838 15.3051L24.4412 15.1425C26.5695 12.8603 26.5096 9.30135 24.3087 7.09555L24.1228 6.9172C21.8564 4.83646 18.3346 4.89591 16.1399 7.09555L15.001 8.23599L13.8634 7.09555C11.6688 4.89591 8.14693 4.83646 5.88052 6.9172L5.69461 7.09555ZM13.1555 7.80186L15.0017 9.65218L16.8478 7.80186C18.7127 5.93271 21.7359 5.93271 23.6008 7.80186C25.4215 9.62661 25.4711 12.5719 23.7161 14.4539L23.5705 14.6044L15.001 23.191L6.40252 14.5734L6.25733 14.4224C4.52885 12.5683 4.58545 9.62305 6.40252 7.80186C8.26744 5.93271 11.2906 5.93271 13.1555 7.80186Z",
        fill: "currentColor"
      }
    )
  );
};
FavoriteNavIcon.iconName = "FavoriteNavIcon";

export { FavoriteNavIcon };
